"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getPromoCode = function getPromoCode(offer) {
  var _offer$canBeRedeemedW;
  var value = offer === null || offer === void 0 || (_offer$canBeRedeemedW = offer.canBeRedeemedWithPromoCode) === null || _offer$canBeRedeemedW === void 0 || (_offer$canBeRedeemedW = _offer$canBeRedeemedW[0]) === null || _offer$canBeRedeemedW === void 0 || (_offer$canBeRedeemedW = _offer$canBeRedeemedW.code) === null || _offer$canBeRedeemedW === void 0 ? void 0 : _offer$canBeRedeemedW.current;
  if (!value) return null;
  return {
    value: value
  };
};
var _default = exports["default"] = getPromoCode;
module.exports = exports.default;